var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"\n    inline-flex\n    px-2\n    font-bold\n    leading-snug\n    text-blue-600\n    uppercase\n    bg-blue-100\n    rounded\n  "},[_vm._v("PRO")])}
var staticRenderFns = []

export { render, staticRenderFns }